import { Tooltip } from "antd";
import { createUseStyles } from "react-jss";

import colors from "../../../../colors";

const useStyles = createUseStyles({
  customIcon: (props) => ({
    fontSize: props.size || 22,
    paddingTop: props.paddingTop || 0,
    marginLeft: props.marginLeft || 0,
    marginRight: props.marginRight || 0,
    color: props.color || colors.RED,
  }),
  customIconTitle: (props) => ({
    maxWidth: props.tooltipWidth,
  }),
});

const CustomIcon = ({
  size,
  color,
  title,
  onClick,
  className,
  icon: Icon,
  marginLeft,
  marginRight,
  tooltipWidth,
}) => {
  const classes = useStyles({
    size,
    color,
    marginLeft,
    marginRight,
    tooltipWidth,
  });
  return (
    <Tooltip title={title} overlayClassName={classes.customIconTitle}>
      <Icon
        onClick={onClick}
        className={`${className} ${classes.customIcon}`}
      />
    </Tooltip>
  );
};

export default CustomIcon;
